cockpitApp.directive('refreshBar', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/detail/journey/refresh-bar',
    controller: 'refreshBarController',
    controllerAs: 'refreshBarCtrl'
  };
});
